import { render, staticRenderFns } from "./contratosContrato.vue?vue&type=template&id=217ac03c"
import script from "./contratosContrato.vue?vue&type=script&lang=js"
export * from "./contratosContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports